<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <Wait
        :show="wait"
        :progress-value="apiProgress"/>
      <v-flex
        xs12
        md8>
        <material-card
          :title="user.user.username"
          color="primary"
          text="Edit Profile">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    :value="dispatch.name"
                    label="Company (disabled)"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    v-model="user.user.username"
                    class="purple-input"
                    label="User Name"/>
                </v-flex>
                <v-flex
                  xs12
                  md4 >
                  <v-text-field
                    v-model="user.user.email"
                    label="Email Address"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6 >
                  <v-text-field
                    v-model="user.user.first_name"
                    label="First Name"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6 >
                  <v-text-field
                    v-model="user.user.last_name"
                    label="Last Name"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="primary"
                    @click="updateProfile">
                    Update Profile
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        xs12
        md4>
        <material-card class="v-card-profile">
          <ImageUpload v-model="avatar">
            <template v-slot:activator>
              <v-avatar
                v-ripple
                v-if="!avatar"
                slot="offset"
                class="mx-auto d-block mb-3"
                size="150px">
                <img :src="user.image">
                <span><v-icon>mdi-camera</v-icon></span>
              </v-avatar>
              <v-avatar
                v-ripple
                v-else
                slot="offset"
                class="mx-auto d-block mb-3"
                size="150px">
                <img :src="avatar.imageUrl">
                <span @click="avatar = null"><v-icon>mdi-close</v-icon></span>
              </v-avatar>
            </template>
          </ImageUpload>
          <v-card-text class="text-xs-center">
            <span
              v-if="showButtons"
              class="mt-2">
              <v-btn
                :loading="saving"
                color="primary"
                @click="uploadImage">
                Save Photo
              </v-btn>
            </span>
            <h6 class="category text-gray font-weight-thin mb-3">{{ department }}</h6>
            <h4 class="card-title font-weight-light">{{ user.user.first_name }} {{ user.user.last_name }}</h4>
            <p class="card-description font-weight-light"/>
            <v-btn
              color="primary"
              round
              class="font-weight-light"
              @click="passwordDialog = true">
              Change Password
            </v-btn>
          </v-card-text>
        </material-card>
      </v-flex>
      <v-snackbar
        v-model="showSnackbar"
        :top="true"
        :multi-line="true"
        :color="snackbarColor"
        dark>
        {{ snackbarText }}
      </v-snackbar>
      <StandardDialog
        :show="passwordDialog"
        :width="500"
        color="secondary">
        <template v-slot:main>
          <v-text-field
            :append-icon="passwordVisibility.old.icon"
            :type="passwordVisibility.old.type"
            v-model="oldPassword.value"
            prepend-icon="mdi-lock"
            class="purple-input"
            label="Old Password"
            @click:append="oldPassword.show = !oldPassword.show"/>
          <v-text-field
            :append-icon="passwordVisibility.new.icon"
            :type="passwordVisibility.new.type"
            v-model="newPassword.value"
            prepend-icon="mdi-lock"
            class="purple-input"
            label="New Password"
            @click:append="newPassword.show = !newPassword.show"/>
          <v-text-field
            :append-icon="passwordVisibility.confirm.icon"
            :type="passwordVisibility.confirm.type"
            v-model="confirmPassword.value"
            prepend-icon="mdi-check-all"
            class="purple-input"
            label="Confirm New Password"
            @click:append="confirmPassword.show = !confirmPassword.show"/>
        </template>
        <template v-slot:actions>
          <v-btn
            color="secondary"
            @click="clearPasswords">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="changePassword">Change Password</v-btn>
        </template>
      </StandardDialog>
    </v-layout>
  </v-container>
</template>

<script>
import Wait from '../components/busie/Wait'
import StandardDialog from '../components/busie/StandardDialog'
import ImageUpload from '../components/busie/ImageUpload'
import ApiFactory from '../api/ApiFactory'
const DispatchApi = ApiFactory.get('dispatchers')
const UserApi = ApiFactory.get('users')

export default {
  components: {
    Wait,
    StandardDialog,
    ImageUpload
  },
  data: () => ({
    user: JSON.parse(localStorage.range_user),
    passwordDialog: false,
    oldPassword: {
      value: null, // null,
      show: false
    },
    newPassword: {
      value: null, // null,
      show: false
    },
    confirmPassword: {
      value: null, // null,
      show: false
    },
    dispatch: {},
    avatar: null,
    saving: false,
    saved: false,
    showWait: true,
    wait: true,
    apiProgress: 0,
    dialog: false,
    snackbarText: '',
    snackbarColor: 'secondary',
    showSnackbar: false
  }),
  computed: {
    showButtons () {
      return (this.avatar && this.saved === false)
    },
    department () {
      var departments = { a: 'Admin', b: 'Supervisor', c: 'Charter', d: 'Dispatch' }
      return departments[this.user.department]
    },
    passwordVisibility () {
      const getIcon = this.getIcon
      const getType = this.getType
      const oldPass = this.oldPassword.show
      const newPass = this.newPassword.show
      const confirmPass = this.confirmPassword.show
      return {
        old: { icon: getIcon(oldPass), type: getType(oldPass) },
        new: { icon: getIcon(newPass), type: getType(newPass) },
        confirm: { icon: getIcon(confirmPass), type: getType(confirmPass) }
      }
    },
    passwordsOk () {
      return this.oldPassword.value && this.newPassword.value && this.confirmPassword.value && (this.confirmPassword.value === this.newPassword.value)
    }
  },
  watch: {
    avatar: {
      deep: true,
      handler () {
        this.saved = false
      }
    },
    showWait: {
      handler (val) {
        if (!val) {
          setTimeout(() => this.wait = false, 500)
        } else {
          this.wait = true
          setTimeout(() => {}, 50)
        }
      }
    },
    showSnackbar: {
      handler (val) {
        if (!val) {
          this.snackbarText = ''
        }
      }
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
  },
  methods: {
    getIcon: (val) => val ? 'mdi-eye' : 'mdi-eye-off',
    getType: (val) => val ? 'text' : 'password',
    fetch () { this.get(this.user.location, this).catch((e) => this.alertError(e)) },
    updateProfile () {
      this.update(this.user, this).then(
        () => this.resetUser()).catch(
        (e) => this.alertError(e))
    },
    resetUser () { this.user = JSON.parse(localStorage.range_user) },
    changePassword () {
      var payload = this.user
      payload.user.password = this.newPassword.value
      payload.old_password = this.oldPassword.value
      this.passwordCheck().then(
        () => this.update(payload, this).then(
          () => this.resetUser())).catch(
        (e) => this.alertError(e))
    },
    uploadImage () {
      setTimeout(
        () => this.upload(this.avatar.formData, this).catch(
          (e) => this.alertError(e)),
        1000)
    },
    alertError (e) { this.parseError(e).then((res) => this.emitError(res)) },
    async passwordCheck () {
      const passwordsOk = this.passwordsOk
      return await new Promise(function (resolve, reject) {
        if (passwordsOk) {
          resolve()
        } else {
          reject({
            message: `Verify that all fields are complete and that your new password matches the password confirmation`
          })
        }
      })
    },
    get: async (loc, vm) => {
      vm.apiProgress = 0
      vm.showWait = true
      const { data } = await DispatchApi.get(loc)
      vm.dispatch = data
      vm.apiProgress = 100
      vm.showWait = false // see watch
    },
    update: async (payload, vm) => {
      delete payload.image
      delete payload.user.username
      vm.apiProgress = 0
      vm.showWait = true
      const { data } = await UserApi.update(vm.user.id, payload)
      localStorage.range_user = JSON.stringify(data)
      vm.apiProgress = 100
      vm.showWait = false // see watch
    },
    upload: async (payload, vm) => {
      let user = JSON.parse(localStorage.range_user)
      vm.saving = true
      vm.apiProgress = 0
      vm.showWait = true
      const { data } = await UserApi.upload(vm.user.id, payload)
      user.image = data.url
      localStorage.range_user = JSON.stringify(user)
      vm.apiProgress = 100
      vm.showWait = false
      vm.saving = false
      vm.saved = true
    },
    clearPasswords () {
      this.oldPassword.value = null
      this.newPassword.value = null
      this.confirmPassword.value = null
      this.passwordDialog = false
    },
    parseError: async (e) => new Promise((resolve) => {
      resolve()
    }),
    emitError (errors) {
      this.user = JSON.parse(localStorage.range_user)
      this.snackbarColor = 'error'
      for (var i = 0; i < errors.length; i++) {
        this.snackbarText = this.snackbarText + errors[i] + '\n'
      }
      this.showSnackbar = true
      this.showWait = false
    }
  }
}
</script>
